import React, {useRef, memo} from 'react';
import {AiFillCloseCircle} from 'react-icons/ai';
import {IoIosArrowForward} from 'react-icons/io';
import logo from '../public/assets/logo.png';
import {categories} from '../lib/data';
import {useStateContext} from '../context/StateContext';
import Image from 'next/image'
import Link from 'next/link';
import VisDiv from './frontend_components/VisDiv';
import CustomerLogo from './CustomerLogo';
import { facilityCompany, technician, clientUser } from '../lib/userPermissions';

const isNotActiveStyle = 'flex items-center px-5 gap-3 text-gray-500 hover:text-black transition-all dur' +
        'ation-200 ease-in-out capitalize';
const isActiveStyle = 'flex items-center px-5 gap-3 font-extrabold border-r-2 border-black  transitio' +
        'n-all duration-200 ease-in-out capitalize';

const Sidebar = memo(({isOpen, onClose, sUser, customer}) => {
  const {client} = useStateContext()

    const sidebarRef = useRef();

    return (

        <div className="cart-wrapper" ref={sidebarRef}>
            <div className="sidebar-container" style={{width: "75%", display: isOpen ? "block" : "none"}}>
                <div className='top-sidebar-container'>
                    <button type="button" className="logo" onClick={onClose}>
                        <Link href="/" passHref>
                          <a>
                           <CustomerLogo/>
                          </a>
                          
                        </Link>
                    </button>
                    <button
                        type="button"
                        className="sidebar-close-button"
                        onClick={onClose}>
                        <AiFillCloseCircle/>

                    </button>
                </div>
                <div className='body-sidebar-container'>
                  <Link href="/" passHref >
                    <a>
                      <VisDiv className={"sidebar-item"} onClick={onClose}>
                              <p>REGISTRI</p>
                      </VisDiv>
                    </a>
                  </Link>
                  <Link href="/offers" passHref >
                    <a>
                      <VisDiv rules={[client, technician(sUser), facilityCompany(customer), clientUser(sUser)]} className={"sidebar-item"} onClick={onClose}>
                              <p>OFFERTE</p>
                      </VisDiv>
                    </a>
                  </Link>
                  <Link href="/pdf" passHref>
                    <a>
                      <VisDiv rules={[client, technician(sUser)]} className={"sidebar-item"} onClick={onClose}>
                              <p>PDF</p>
                      </VisDiv>
                    </a>
                  </Link>
                  <Link href="/docs-management" passHref>
                    <a>
                      <VisDiv rules={[technician(sUser), facilityCompany(customer), clientUser(sUser)]} className={"sidebar-item"} onClick={onClose}>
                              <p>DOCUMENTI</p>
                      </VisDiv>
                    </a>
                  </Link>
                  <VisDiv rules={[facilityCompany(customer)]} className={"sidebar-title"}>
                    <h3> REPORT</h3>
                  </VisDiv>
                  <Link href="/reports/client-assets" passHref>
                    <a>
                      <VisDiv rules={[]} className={"sidebar-item"} onClick={onClose}>
                              <p>CLIENTE</p>
                      </VisDiv>
                    </a>
                  </Link>
                  <Link href="/reports/order" passHref>
                    <a>
                      <VisDiv rules={[clientUser(sUser)]} className={"sidebar-item"} onClick={onClose}>
                           <p>ORDINE E FOGLIO DI LAVORO</p>
                      </VisDiv>
                    </a>
                  </Link>
                  <Link href="/reports/tech-activities" passHref>
                    <a>
                      <VisDiv rules={[technician(sUser),clientUser(sUser)]} className={"sidebar-item"} onClick={onClose}>
                           <p>ATTIVITA' TECNICO</p>
                      </VisDiv>
                    </a>
                  </Link>
                  <VisDiv rules={[technician(sUser),  facilityCompany(customer), clientUser(sUser)]} className={"sidebar-title"}>
                    <h3> ANAGRAFICHE</h3>
                  </VisDiv>
                  <Link href="/management/clients" passHref>
                    <a>
                      <VisDiv rules={[technician(sUser), facilityCompany(customer), clientUser(sUser)]} className={"sidebar-item"} onClick={onClose}>
                              <p>CLIENTI</p>
                      </VisDiv>
                    </a>
                  </Link>
                  <Link href="/management/sites" passHref>
                    <a>
                      <VisDiv rules={[technician(sUser), facilityCompany(customer), clientUser(sUser)]} className={"sidebar-item"} onClick={onClose}>
                              <p>PLESSI</p>
                      </VisDiv>
                    </a>
                  </Link>
                  <Link href="/management/email" passHref>
                    <a>
                      <VisDiv rules={[technician(sUser), facilityCompany(customer), clientUser(sUser)]} className={"sidebar-item"} onClick={onClose}>
                              <p>UTENTI</p>
                      </VisDiv>
                    </a>
                  </Link>
                  <VisDiv rules={[technician(sUser), facilityCompany(customer), clientUser(sUser)]} className={"sidebar-title"}>
                    <h3> GESTIONE MODELLI</h3>
                  </VisDiv>
                  <Link href="/management/register-templates" passHref>
                    <a>
                      <VisDiv rules={[technician(sUser), facilityCompany(customer),clientUser(sUser)]} className={"sidebar-item"} onClick={onClose}>
                              <p>REGISTRI</p>
                      </VisDiv>
                    </a>
                  </Link>
                  <Link href="/management/offer-templates" passHref>
                    <a>
                      <VisDiv rules={[technician(sUser), facilityCompany(customer), clientUser(sUser)]} className={"sidebar-item"} onClick={onClose}>
                              <p>OFFERTE</p>
                      </VisDiv>
                    </a>
                  </Link>
{/*                   <VisDiv className={"sidebar-item"} onClick={() => setShowSidebar(false)}>
                      <Link href="/manage">
                          <p>GESTIONE NON CONFORMITA'</p>
                      </Link>
                  </VisDiv> */}
                </div>

            </div>
        </div>
    )

}

);

export default Sidebar;

/*






--------


bottone chiudi

          <NavLink
            to="/"
            className={({ isActive }) => (isActive ? isActiveStyle : isNotActiveStyle)}
            onClick={handleCloseSidebar}
          >
            <RiHomeFill />
            Home
          </NavLink>



  return (
    <div className="flex flex-col justify-between bg-white h-full overflow-y-scroll min-w-210 hide-scrollbar">
      <div className="flex flex-col">
        <Link
          to="/"
          className="flex px-5 gap-2 my-6 pt-1 w-190 items-center"
          onClick={handleCloseSidebar}
        >
          <img src={logo} alt="logo" className="w-full" />
        </Link>
        <div className="flex flex-col gap-5">

          <NavLink
            to="/"
            className={({ isActive }) => (isActive ? isActiveStyle : isNotActiveStyle)}
            onClick={handleCloseSidebar}
          >
            <RiHomeFill />
            Home
          </NavLink>
          <h3 className="mt-2 px-5 text-base 2xl:text-xl">Registri</h3>
          {categories.slice(0, categories.length - 1).map?.((category) => (
            <NavLink
              to={`/category/${category.name}`}
              className={({ isActive }) => (isActive ? isActiveStyle : isNotActiveStyle)}
              onClick={handleCloseSidebar}
              key={category.name}
            >
              <img src={category.image} className="w-8 h-8 rounded-full shadow-sm" />
              {category.name}
            </NavLink>
          ))}
        </div>
      </div>
      {user && (
        <Link
          to={`user-profile/${user._id}`}
          className="flex my-5 mb-3 gap-2 p-2 items-center bg-white rounded-lg shadow-lg mx-3"
          onClick={handleCloseSidebar}
        >
          <img src={user.image} className="w-10 h-10 rounded-full" alt="user-profile" />
          <p>{user.userName}</p>
          <IoIosArrowForward />
        </Link>
      )}
    </div>
  )

*/
